import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=153d05fe&scoped=true&"
import script from "./TheFooter.vue?vue&type=script&lang=js&"
export * from "./TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=153d05fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d05fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookieLaw: require('/usr/src/motec/components/CookieLaw.vue').default})
